import { useState } from "react";
import { faqItems } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="chigua-container mx-auto">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* intro side */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHeading
              eyebrow="吃瓜百科"
              title="关于吃瓜，你可能有这些疑问"
              desc="把「吃瓜」吃得专业又体面，从相信什么、怎么判断，到补课路径与投稿方式，FAQ 里都有答案。"
            />
            <div className="mt-6 rounded-3xl bg-background-50 p-5">
              <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-800">
                <i className="ri-git-branch-line text-primary-500"></i> 看瓜三问
              </h4>
              <ol className="mt-3 space-y-3 text-sm text-foreground-600">
                <li className="flex gap-3">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-primary-500 text-xs font-bold text-background-50">1</span>
                  信源是谁？有没有当事人或权威回应？
                </li>
                <li className="flex gap-3">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-accent-600 text-xs font-bold text-background-50">2</span>
                  时间线顺不顺？是否仍在下结论的路上？
                </li>
                <li className="flex gap-3">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-secondary-600 text-xs font-bold text-background-50">3</span>
                  会不会反转？有没有被断章取义的可能？
                </li>
              </ol>
            </div>
          </div>

          {/* accordion */}
          <div className="space-y-3 lg:col-span-2">
            {faqItems.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <span className={`text-[15px] font-semibold ${isOpen ? "text-primary-700" : "text-foreground-800"}`}>
                      {item.q}
                    </span>
                    <span
                      className={`grid h-7 w-7 shrink-0 place-items-center rounded-full text-sm transition-all ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                      }`}
                      aria-hidden="true"
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="border-l-2 border-primary-300 pl-4 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}